$('.js-contactFormButton').on('click', () => {
  $('.js-contactForm').addClass('is_active')
})

$('.js-contactFormClose').on('click', () => {
  $('.js-contactForm').removeClass('is_active')
})